import ApiConstants from "../../../constants/ApiConstants";
import http from "../../../http";

export default class ImportService {
    static getRequestURL(endPointKey, queryParamObj) {
        const { BASE, IMPORT_EXPORT } = ApiConstants.URL;
        let queryParams = "";

        if (queryParamObj && Object.keys(queryParamObj).length) {
            queryParams = `?${new URLSearchParams(queryParamObj).toString()}`;
        }

        const endPoint = IMPORT_EXPORT[endPointKey];

        return `${BASE}${endPoint}${queryParams}`;
    }

    static getApiRequestOptions(method, body = null, type) {
        const requestOptions = {
            method: method,
            credentials: "include",
            withCredentials: true,
            mode: "cors",
        };

        if (type === "json") {
            return {
                ...requestOptions,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            };
        } else if (method === "POST" || method === "PUT") {
            return {
                ...requestOptions,
                body,
            };
        }

        return requestOptions;
    }

    static async getUploadFileURL(fileData, fileEntity) {
        const url = ImportService.getRequestURL("UPLOAD_FILE");

        const formData = new FormData();
        formData.append("file", fileData);
        formData.append("file-entity", fileEntity);

        const requestOptions = ImportService.getApiRequestOptions("POST", formData);

        return fetch(url, requestOptions)
            .then((res) => res.json())
            .catch((err) => Promise.reject(err));
    }

    static async uploadRecords(queryParamObj = {}, payload) {
        const url = ImportService.getRequestURL("UPLOAD_RECORDS", queryParamObj);

        const requestOptions = ImportService.getApiRequestOptions(
            "POST",
            payload,
            "json"
        );

        return fetch(url, requestOptions)
            .then((res) => res.json())
            .catch((err) => Promise.reject(err));
    }

    static async saveAuditLog(payload) {
        const url = ImportService.getRequestURL("AUDIT_LOG");
        const requestOptions = ImportService.getApiRequestOptions(
            "POST",
            payload,
            "json"
        );

        return fetch(url, requestOptions)
            .then((res) => res.json())
            .catch((err) => Promise.reject(err));
    }

    static async getColumnMapping(queryParamObj) {
        const url = ImportService.getRequestURL("COLUMN_MAPPING", queryParamObj);
        const requestOptions = ImportService.getApiRequestOptions("GET");

        return fetch(url, requestOptions)
            .then((res) => res.json())
            .catch((err) => Promise.reject(err));
    }

    static async import(payload, queryParamObj) {
        const url = ImportService.getRequestURL("IMPORT", queryParamObj);
        const requestOptions = ImportService.getApiRequestOptions(
            "POST",
            payload,
            "json"
        );

        return fetch(url, requestOptions)
            .then((res) => res.json())
            .catch((err) => Promise.reject(err));
    }
}
